import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Panel} from "../../../../framework/model/core/panel/panel";
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {AppDataService} from "../../../services/AppDataService";
import {ItemProvider} from "../../../pages/item/providers/item-provider/item-provider.service";
import {MainService} from "../../../services/MainService";
import {OrderService} from "../../../services/OrderService";
import {AppUser} from "../../../../framework/model/core/appuser/appuser";
import {BusinessService} from "../../../services/BusinessService";
import {Events} from "../../../../framework/providers/events";
import {AdminService} from "../../../services/AdminService";

@Component({
    selector: 'app-panel',
    templateUrl: './app-panel.component.html',
    styleUrls: ['./app-panel.component.scss'],
})
export class AppPanelComponent implements OnInit {
    @Input()
    public models: Array<Panel> = [];

    public filters: object = {'ordering': 'order', 'removed': false, 'active':true};

    @Input()
    public key;

    ready = true;
    public appuser: AppUser;

    constructor(public events: Events, public orderService: OrderService, public adminService: AdminService) {
        this.events.subscribe('appuserChanged', (res) => {
            this.appuser = this.orderService.getAppUser();
        });

        this.appuser = this.orderService.getAppUser();
    }

    ngOnInit() {
        this.filters['key'] = this.key;
        this.filters['limit'] = 100;

    }

    refresh() {
        let me = this;
        this.ready = false;
        setTimeout(function () {
            me.ready = true;
        })
    }


}
